import { css, useTheme } from "@emotion/react";
import React, { useState } from "react";

import generateUniqueId from "./generateUniqueId";
import MaybeFragment from "./MaybeFragment.jsx";

export default function Checkbox({
  // name,
  id,
  type = "checkbox",
  label,
  // value,
  inputProps,
  labelProps,
  wrapperProps,
  className,
  ...restProps
}) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  const [defaultId] = useState(() => `checkbox-${generateUniqueId()}`);
  id = id ?? defaultId;

  return (
    <MaybeFragment
      className={className}
      css={css`
        display: flex;
        align-items: baseline;
        gap: ${theme.getLength(1)};
      `}
      {...wrapperProps}
    >
      <input
        type={type}
        // name={name}
        id={id}
        // value={value}
        {...inputProps}
        {...restProps}
        css={css`
          position: relative;
          top: 0.0625em;
        `}
      />
      <label htmlFor={id} {...labelProps}>
        {label}
      </label>
    </MaybeFragment>
  );
}
